// @flow
import React, { Component } from 'react';

import style from './style.css';

type Props = {
  children: Array<React$Element<*>>;
};

class Docs extends Component<void, Props, void> {
  render() {
    return (
      <div className={`full-page bg-light text-light pv3 ${style.docs}`}>
        <div className={style.docsInner}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Docs;
export { default as S } from './style.css';



// WEBPACK FOOTER //
// ./src/pages/Docs/index.jsx